import TableIds from '../../../constants/tableIds';
import SortDirection from '../../../enums/sortDirection';
import notificationsService from '../../../services/notificationsService';
const notificationsTableConfig = {
    id: TableIds.NOTIFICATIONS,
    initialSort: {
        key: 'date',
        direction: SortDirection.Descending
    },
    initialPagination: {
        pageNumber: 1,
        pageSize: 10
    },
    fetchData: notificationsService.getNotifications,
    actionsConfig: {
        hasHideableColumns: false,
        hasExport: false,
        hasFilter: false,
        hasSearch: false
    },
    scrollableTableWidth: 1000,
    tableHeight: 350
};
export default notificationsTableConfig;
